<template>
    <MainLayout class="c-jiwei-land-detail">
        <BgWrap slot="left" class="c-jiwei-land-detail__left">
            <Left @treeChildreClick="handleLeftClick"></Left>
        </BgWrap>
        <div slot="main" class="c-jiwei-land-detail__main">
            <Middle :landName="landName" :landId="id"></Middle>
        </div>
        <BgWrap slot="right" class="c-jiwei-land-detail__right">
            <Right :id="id"></Right>
        </BgWrap>
    </MainLayout>
</template>

<script>
import MainLayout from '../../layout/MainLayout';
import BgWrap from '../../layout/components/BgWrap.vue';
import Middle from './Middle/Middle.vue';
import Right from './Right/Right.vue';
import Left from '../left.vue';
// import * as Api from '../Api';

export default {
    components: {
        MainLayout,
        BgWrap,
        Middle,
        Right,
        Left,
    },
    data() {
        return {
            id: '',
            landName: '',
        };
    },
    methods: {
        handleLeftClick(data) {
            // this.$router.push({ path: '/jiwei/land/detail', query: { id: data.id, name: data.name } });
            this.$route.query.id = data.id;

            this.$route.query.name = data.name;

            this.getRouteQuery();
        },
        // 获取路由参数
        getRouteQuery() {
            const query = this.$route.query;
            if (query) {
                this.id = query.id;
                this.landName = query.name;
            }
        },
    },
    created() {
        this.getRouteQuery();
    },
    mounted() {},
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';
$bg-1: #071150;
$bg-2: #03053d;
$bg-3: #c4c4c4;

@include b(jiwei-land-detail, c) {
    color: #fff;
    background: $bg-2;
    padding: 18px 8px 8px 8px;

    @include e(content) {
        padding: 10px;
        height: calc(100% - 20px);
    }

    @include e(left) {
        height: 100%;
        background-color: $bg-1;
    }

    @include e(main) {
        height: 100%;
        margin: 0px 10px;
    }

    @include e(right) {
        height: 100%;
        // background-color: $bg-3;
        background-color: $bg-1;
    }
}
</style>
